import { useTheme } from "../../../../context/useThemeContext";
import useDataStore from "../../../../stores/dataStore";

function NoteDate(props: { noteID: string }) {
    const { theme } = useTheme();
    const createdAt = useDataStore(
        (state) => state.data.notes[props.noteID]?.createdAt
    );

    const date = new Date(createdAt).toLocaleDateString("en-US", {
        month: "numeric",
        day: "numeric",
        year: "2-digit",
    });

    return (
        <p
            className="note-date text-xs"
            style={{
                color: theme.fontColor[300],
            }}
        >
            {date}
        </p>
    );
}

export default NoteDate;
